import styled from 'styled-components';

export const TagWrapper = styled.div`
  height: 27px;
  width: fit-content;
  padding: 0px 12px;
  justify-content: center;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 9px;
  border: 1px solid ${({ theme }) => theme.colors.link};
  color: ${({ theme }) => theme.colors.link};
  cursor: pointer;
  transition: ${(props) => props.theme.constants.transitionBase};

  &.active,
  &:hover {
    background-color: ${({ theme }) => theme.colors.bgBox};
  }
`;
